import type { DashboardPeriod, DashboardStats, MessageTrend } from '@/services/dashboardApi'
import { AttentionCenter } from './AttentionCenter'
import WarrantyCoverageAlert from './WarrantyCoverageAlert'
import SetupChecklist from './SetupChecklist'
import { KpiRow } from './KpiRow'
import { ChannelsPanel } from './ChannelsPanel'
import { ActivityTimeline } from './ActivityTimeline'
import { TeamsPanel } from './TeamsPanel'
import type { QualityMetrics } from './dashboardMetrics'

export interface DashboardSummaryPanelProps {
  stats: DashboardStats
  hasAnyChannel: boolean
  metrics: QualityMetrics
  period: DashboardPeriod
  trendPoints?: MessageTrend[]
  trendLoading?: boolean
}

/** Primer vistazo: lo accionable, los 4 KPIs y el estado operativo. */
export function DashboardSummaryPanel({
  stats,
  hasAnyChannel,
  metrics,
  period,
  trendPoints,
  trendLoading,
}: DashboardSummaryPanelProps) {
  return (
    <section
      id="dashboard-panel-summary"
      role="tabpanel"
      aria-labelledby="dashboard-tab-summary"
      tabIndex={0}
      className="space-y-6 focus:outline-none"
    >
      <AttentionCenter
        pendingAppointments={stats.overview.pendingAppointments}
        hasAnyChannel={hasAnyChannel}
      />

      <WarrantyCoverageAlert />

      <div data-tour="dashboard-setup">
        <SetupChecklist activeProducts={stats.overview.activeProducts} />
      </div>

      <KpiRow
        stats={stats}
        metrics={metrics}
        period={period}
        trendPoints={trendPoints}
        trendLoading={trendLoading}
      />

      <ChannelsPanel instances={stats.instances} />

      <ActivityTimeline
        activity={stats.recentActivity}
        hasChannels={stats.instances.length > 0}
      />

      <TeamsPanel teams={stats.teams} />
    </section>
  )
}
